{
	"deploymentId": "20260623T205324Z",
	"chainId": 8453,
	"deployedAt": "2026-06-23T20:53:24.530Z",
	"contracts": {
		"FSEnvelopeRegistry": {
			"address": "0xd119ff5bBaF6Aa81531dc1f75a8fA80463ec1478",
			"abiRef": "ff0785f2d6ec18ac54f04caf8944b32e80931b6e0ba747eea0e46e53494cbb12"
		},
		"FSPaymentValidator": {
			"address": "0x5eE2733E131D8DF2f0c7e8618A9F7c2E16dba939",
			"abiRef": "5c06b1840e1e307bec4b426803081be2250b1a16a89ed3a3272000bfc5fd0d8f"
		},
		"FSAttachmentRelease": {
			"address": "0x363413aD8528Db9050E042D9B6bF0d75ad05d9d3",
			"abiRef": "bc37a8c681af0849ace7cde4b7005b58679dff2abe8276aaedbdeb31e77ee0e9"
		}
	},
	"transactions": {
		"setSatelliteContracts": "0xf7f8c5a7c75082c4fcc63a12073a8ee65f9a269022a5cea617b20bf99f27b437"
	},
	"deploy": {
		"initialRelayers": [
			"0x0357389806ef93C66B307562D29b4D704D1554a3",
			"0x534c7DA993a6c65977629C0b6deA11ce3320e033"
		]
	}
}
